// Configuration file for API endpoints

// // Determine the backend URL from environment variables, with a fallback for safety.
// const backendUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
const backendUrl = process.env.REACT_APP_API_URL;

// Check if we're running locally by examining the hostname
const isLocalHost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// Create a singleton configuration
const config = {
  // Backend URL is now reliably sourced from environment variables
  backendUrl: backendUrl,

  // Frontend URL - should match the PORT in .env file
  frontendUrl: isLocalHost ? "http://localhost:3001" : "http://localhost:3001",

  // Other API configurations can be added here
  dictionaryApi: "https://api.dictionaryapi.dev/api/v2/entries/en/",

  // Keep track of whether we're using fallback
  usingFallbackBackend: false,

  // Flag to track if we've already checked backend availability
  hasCheckedBackend: false,

  // Flag to reduce console warnings
  hasWarnedAboutBackend: false,
};

// This function now simply returns the configured backend URL.
export const getBackendUrl = () => {
  return config.backendUrl;
};

// The checkBackendAvailability function is no longer needed as we trust the .env file.
export const checkBackendAvailability = async () => {
  // Always return true, assuming the .env config is correct.
  return true;
};

// Export a synchronous URL getter that doesn't do availability checking
// Use this for non-critical UI elements where an async function would be inconvenient
export const getCurrentBackendUrl = () => {
  // If already using fallback or already checked, return current URL
  if (config.usingFallbackBackend || config.hasCheckedBackend) {
    return config.backendUrl;
  }

  // If on localhost but haven't checked yet, we'll assume we need production
  // This avoids UI glitches while the async check is happening
  if (isLocalHost) {
    return config.prodBackendUrl;
  }

  // Otherwise return the configured URL
  return config.backendUrl;
};

// Try to verify backend availability when loaded
// Use setTimeout to avoid blocking the initial render
if (isLocalHost) {
  setTimeout(() => {
    checkBackendAvailability().then((isAvailable) => {
      if (!isAvailable) {
        // This runs after the initial check, so we don't need to log again
        config.backendUrl = config.prodBackendUrl;
        config.usingFallbackBackend = true;
      }
    });
  }, 0);
}

export default config;

// API URL Configuration - Use the same dynamic backend URL as the rest of the app
export const API_BASE_URL = config.backendUrl;
// export const API_BASE_URL = "http://localhost:3000";
// export const API_BASE_URL = "https://flying-raven-gladly.ngrok-free.app"

// Other app-wide configurations
export const APP_NAME = "SyntaxMap";
export const APP_VERSION = "1.0.0";

// Routes configuration
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  PASSWORD_RECOVERY: "/password-recovery",
  PROFILE: "/profile",
  TENSES: "/tenses",
  TENSE_DETAILS: "/tenses/:id",
  PRACTICE: "/practice",
  QUIZ: "/quiz",
  RESOURCES: "/resources",
  PROGRESS: "/progress",
  NOTIFICATIONS: "/notifications",
  NOT_FOUND: "*",
};
